import { render, staticRenderFns } from "./YarnIcon.vue?vue&type=template&id=3b8e8d3e&scoped=true"
import script from "./YarnIcon.vue?vue&type=script&lang=js"
export * from "./YarnIcon.vue?vue&type=script&lang=js"
import style0 from "./YarnIcon.vue?vue&type=style&index=0&id=3b8e8d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8e8d3e",
  null
  
)

export default component.exports